const initialState = {
  // General metrics
  fetchingGeneralMetrics: false,
  householdData: {},
  portfolioData: {},
  userData: {},
  generalMetricsError: "",
};

export default function user(state = initialState, action) {
  switch (action.type) {
    case "GENERAL_METRICS_REQUESTED":
      return {
        ...state,
        fetchingGeneralMetrics: true,
        generalMetricsError: "",
      };
    case "GENERAL_METRICS_SUCCESS":
      return {
        ...state,
        fetchingGeneralMetrics: false,
        householdData: action.payload.data.householdData,
        portfolioData: action.payload.data.portfolioData,
        userData: action.payload.data.userData,
      };
    case "GENERAL_METRICS_FAIL":
      return {
        ...state,
        fetchingGeneralMetrics: false,
        generalMetricsError: action.payload.response.data.error,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/metric.reducer.js